import { render } from "./FlexMessageTree.vue?vue&type=template&id=1ccaacc8"
import script from "./FlexMessageTree.vue?vue&type=script&lang=ts"
export * from "./FlexMessageTree.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
